export default function CourseCard({ course, navigate, onEnroll }) {
  return (
    <article className="courses-page-card">
      <div className="courses-page-image-wrap">
        <img src={course.image} alt={course.cardTitle} />
      </div>
      <h3>{course.title}</h3>
      <div className="courses-page-rating">
        {"★".repeat(5)} <span>({course.rating} / {course.ratingsCount} Ratings)</span>
      </div>
      <div className="courses-page-actions">
        <button
          type="button"
          className="courses-page-btn primary"
          onClick={() => onEnroll(course.slug)}
        >
          Enroll
        </button>
        <button
          type="button"
          className="courses-page-btn secondary"
          onClick={() => navigate(`/courses/${course.slug}#syllabus`)}
        >
          View Syllabus
        </button>
      </div>
    </article>
  );
}
